module.exports = __webpack_public_path__ + "img/tb-9.4f7864ab.png";